/**
 * 企业版相关的打点
 * 企业版首页
 */

export default {
  /**
   * 企业版首页展示
   */
  enterpriseHomepageShow() {
    this.collect('enterprise_homepage_show', { show: 'enterprise' });
  },

  /**
   * 企业版首页页尾展示
   */
  enterpriseHomepageEndShow({view}) {
    this.collect('enterprise_homepage_end', { view });
  },

  /**
   * 企业版首页点击
   * @param {*} click 点击
      banner|顶部banner点击;
      custom|立即定制;
      introduction|产品介绍;
      cloud|WPS+云办公;
      livebroadcast|直播回放;
      more|查看更多;
      contact|联系我们
   * @param {*} area 点击区域
      training|培训体系;
      service|服务定制;
      elite|精英团队;
      video|视频学习;
      about|关于我们
   * @param {*} type 文章ID
   */
  enterpriseHomepageClick({ click = null, area = null, type = null }) {
    if (!click) {
      this.collect('enterprise_homepage_click', {
        area,
        type,
      });
      return;
    }

    if (!type) {
      if (!area) {
        this.collect('enterprise_homepage_click', {
          click,
        });
      } else {
        this.collect('enterprise_homepage_click', {
          click,
          area,
        });
      }
    } else {
      this.collect('enterprise_homepage_click', {
        click,
        area,
        type,
      });
    }
  },
};
